const { subscriptionsInit } = require('./subscriptionsInit');

function initialization() {
    //subscribe topics
    subscriptionsInit();
}

module.exports = { initialization }